import Layout from '@/components/layouts/Layout';
import DevtoolsClaimPanel from '@/features/claimPanel/Devtools';
import { CaseCardVariants } from '@/features/v2/MobileMenu';
import cn from '@/utils/cn';

import Login from './features/Login';
import Panel from './features/Panel';
import { LoginProvider, useLoginContext } from './lib/login';

export const SESSION_STORAGE_HASH_ITEM_NAME = 'hf_claim_panel_hash';
export const SESSION_STORAGE_DATA_ITEM_NAME = 'hf_claim_panel_data';

const ClaimPanel = () => {
  const { handleLogout, isLoggingIn } = useLoginContext();

  return (
    <Layout
      withoutProgress
      navbarProps={
        isLoggingIn
          ? {
              disableMobileMenu: false,
              caseCardVariant: CaseCardVariants.CLAIM_PANEL,
              onLogoutClick: handleLogout,
            }
          : {
              disableMobileMenu: true,
              compactPhoneButton: true,
              caseCardVariant: CaseCardVariants.EMPTY,
              withoutPhone: true,
            }
      }
      className="[&>main>div]:space-y-10 [&>main>div]:lg:space-y-10 [&>main]:pb-[60px] [&>main]:lg:pt-[40px]"
      mainClassName={cn(
        isLoggingIn
          ? 'relative max-w-full pb-6 xxs:pb-6 md:px-4'
          : 'min-h-[580px]'
      )}
    >
      <div className="flex w-full justify-center">
        <Login show={!isLoggingIn} />
        <Panel show={isLoggingIn} />
      </div>
    </Layout>
  );
};

const AppClaimPanel = () => {
  const showDevtools = import.meta.env.VITE_SHOW_DEV_TOOLS === 'true';

  return (
    <LoginProvider>
      <ClaimPanel />
      {showDevtools && (
        <>
          <DevtoolsClaimPanel />
        </>
      )}
    </LoginProvider>
  );
};

export default AppClaimPanel;
